class SingleProduct {
	constructor() {
		if (!document.body.classList.contains("single-product")) {
			return;
		}
		this.banner = document.querySelector(".banner-product");
		this.image = document.querySelector(".banner-product .shadow-container");
		this.downloads = document.querySelector(".downloads-container");

		this.buildGallery();

		if (this.downloads) {
			this.setDownloadSectionMargin();
			resizeCallbacks.push(this);
		}
	}

	setDownloadSectionMargin() {
		if (window.innerWidth > 767) {
			this.downloads.style.marginTop = this.image.clientHeight - this.banner.clientHeight + 100 + "px";
		} else {
			this.downloads.style.marginTop = "0px";
		}
	}

	buildGallery() {
		const gallery = document.querySelector(".swiper-product-gallery");
		if (gallery) {
			new Swiper(gallery, {
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				navigation: {
					nextEl: '.banner-product .next',
					prevEl: '.banner-product .prev',
				}
			});
		}
	}

	resize() {
		this.setDownloadSectionMargin();
	}
}
